<template>
  <div class="calendar">
    <CdrButton
      :icon-only="true"
      :class="btnClass"
      title="Add to calendar"
      aria-label="Open add to calendar modal"
      aria-haspopup="dialog"
      data-ui="add-to-calendar-modal-button"
      @click="openModal"
    >
      <template #icon>
        <IconCalendar aria-hidden="true" />
      </template>
    </CdrButton>
    <CdrModal
      id="add-to-calendar-modal"
      :opened="modalOpened"
      label="Add to calendar"
      aria-described-by="add-to-calendar-description"
      data-ui="add-to-calendar-modal"
      @closed="closeModal"
    >
      <template #title>
        <CdrText
          tag="h3"
          class="calendar__title"
        >
          Add to calendar
        </CdrText>
      </template>
      <ModalContent
        :session-id="modalData.eventSessionId"
        :event-registration-status="modalData.eventRegistrationStatus"
        :event-start="modalData.eventStart"
        :event-end="modalData.eventEnd"
        :event-title="modalData.eventTitle"
        :event-location-name="modalData.eventLocationName"
        :event-uri="modalData.eventUri"
      />
    </CdrModal>
  </div>
</template>

<script>
import { CdrButton, CdrModal, CdrText, IconCalendar } from '@rei/cedar';
import ModalContent from './modalContent.vue';
import metrics from '../../../mixins/metrics';

export default {
  name: 'AddToCalendar',
  components: {
    CdrButton,
    CdrModal,
    CdrText,
    IconCalendar,
    ModalContent,
  },
  mixins: [metrics],
  props: {
    modalData: {
      type: Object,
      required: true,
    },
    btnClass: {
      type: String,
      required: false,
      default: null,
    },
  },
  data: () => ({
    modalOpened: false,
  }),
  methods: {
    openModal() {
      this.modalOpened = true;
      const linkName = '{{ pageName }}_add to calendar modal_open';
      this.metricsClick({ linkName });
    },
    closeModal() {
      this.modalOpened = false;
      const linkName = '{{ pageName }}_add to calendar modal_close';
      this.metricsClick({ linkName });
    },
  },
};
</script>
